// components/modals/ReprogramarPrestamoModal.js
import React from 'react';

const ReprogramarPrestamoModal = ({
  show,
  onClose,
  selectedPrestamo,
  reprogramarForm,
  errors,
  handleInputChange,
  handleConfirmAction
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-panel modal-panel-sm p-6">
        <h3 className="modal-title mb-4">
          Reprogramar Préstamo #{selectedPrestamo.idPrestamo}
        </h3>

        <div className="mb-4">
          <p className="modal-text mb-1">
            Préstamo: #{selectedPrestamo.idPrestamo} - {selectedPrestamo.modalidad}
          </p>
          <p className="modal-text mb-1">
            Monto: S/ {parseFloat(selectedPrestamo.monto).toFixed(2)}
          </p>
        </div>

        <div className="mb-4">
          <label className="modal-label">
            Tasa de Interés (%)
          </label>
          <input
            type="number"
            name="tasa_interes"
            value={reprogramarForm.tasa_interes}
            onChange={handleInputChange}
            className={`modal-input ${errors.tasa_interes ? 'border-red-500' : ''}`}
            step="0.1"
            min="1"
            max="5"
          />
          {errors.tasa_interes && (
            <p className="text-red-500 text-xs mt-1">{errors.tasa_interes}</p>
          )}
        </div>

        <div className="mb-4">
          <label className="modal-label">
            Observaciones (opcional)
          </label>
          <textarea
            name="observaciones"
            value={reprogramarForm.observaciones}
            onChange={handleInputChange}
            className="modal-textarea"
            rows="2"
            maxLength="255"
          ></textarea>
        </div>

        <div className="modal-actions">
          <button
            onClick={onClose}
            className="btn-modal-neutral"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirmAction}
            className="btn-modal-primary"
          >
            Reprogramar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReprogramarPrestamoModal;
